// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';

type Props = {
  sourceText: ?React.Fragment,
  definitionText: ?React.Fragment,
}

function MarketingFactTooltip({ sourceText, definitionText }: Props) {
  return (
    <div>
      {
        sourceText && (
          <div>
            <b><Translate value="tooltip.source" /> </b>
            {sourceText}
          </div>
        )
      }
      {
        definitionText && (
          <div>
            <b><Translate value="tooltip.definition" /> </b>
            {definitionText}
          </div>
        )
      }
    </div>
  );
}

export default MarketingFactTooltip;
